//------------------------------------------------------------------
// 定義
//------------------------------------------------------------------
export enum WhereCode { // 
    Reimbursement = 1,
    Appropriation = 2,
    Deposit = 3,
    SingleReimbursement = 4,
    SingleAppropriation = 5,
    SingleDeposit = 6
}


export const ScheduleReport = {
    WhereCode,
};
